// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D2aaR6a","modal":"_5D16x3N3","extended":"_5DOB5M2B"};